import { render, staticRenderFns } from "./ChannelContainer.vue?vue&type=template&id=06e58d5a&scoped=true&"
import script from "./ChannelContainer.vue?vue&type=script&lang=js&"
export * from "./ChannelContainer.vue?vue&type=script&lang=js&"
import style0 from "./ChannelContainer.vue?vue&type=style&index=0&id=06e58d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e58d5a",
  null
  
)

export default component.exports